const Qs = require('qs');
const urlSendDmpData = '/api/dmp';


const DMPPROF_ID = 1;


class DmpProf {

    constructor(vitrina) {

        if (!vitrina.dmpAttributeTaxonomy || !vitrina.dmpAttributeTaxonomy[DMPPROF_ID]) return;

        this.taxonomy = vitrina.dmpAttributeTaxonomy;

        this.events = vitrina.events;
        this.vitrina = vitrina;



        this.events.subscribe('EVENT_LOAD_PAGE', page => {

            if (Object.keys(this.vitrina).length !== 0) {
                this.sendDataDmp(vitrina.uid, vitrina.audiences, vitrina.query);
            }
        });
    }


    sendDataDmp(uid, audiences, query)
    {
        let out = this.vitrina._getPixelUriObject(query);
        let outDmp = [];
        //{"11":1,"14":1,"17":1,"22":1,"23":1,"37":1}
        for(let i in audiences) {
            console.log('audience', i);
            if (!this.isSend(audiences[i])) continue;
            let kv = this.getValueAndName(i);
            if (kv) outDmp.push({value: kv});
        }

        if (outDmp.length === 0) {
            return;
        }

        out.dmp = JSON.stringify(outDmp);

        //отправляем на сервер
        fetch(this.vitrina.host + urlSendDmpData, {
            credentials: 'include',
            method:'POST',
            body: Qs.stringify(out),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
                // 'Content-Type': 'application/json'

            }
        }).catch(e => {
            this.vitrina.reachGoalError('send dmp ' + e.message)
        });

    }

    getValueAndName(id) {
        for (let i in this.taxonomy[DMPPROF_ID]) {
            if (this.taxonomy[DMPPROF_ID][i].id_property == id) {
                return this.taxonomy[DMPPROF_ID][i].dmp_config_id;
            }
        }
        return null;
    }

    isSend(date)
    {

        let start = new Date();
        start.setHours(0,0,0,0);
        console.log('start', new Date(start.getTime()));
        console.log('dmp date', new Date(date * 1000));
        //если дата не сегодня, отправляем
        if (date * 1000 < start.getTime()) return true;

        // if (!this.vitrina.dmp_created_at) return false;
        // let now = (Date()).getTime();
        // let dmpCreatedAt = (Date(this.vitrina.dmp_created_at)).getTime();
        // let start = (new Date()).setHours(0,0,0,0).getTime();
        // let dmpCreatedAtDate = (new Date(this.vitrina.dmp_created_at)).setHours(0,0,0,0).getTime();
        // console.log('now', new Date(now));
        // console.log('dmpCreatedAt', new Date(dmpCreatedAt));
        // console.log('dmpCreatedAtDate', new Date(dmpCreatedAtDate));
        //
        // console.log('start', new Date(start));
        //
        //
        // return Object.keys(this.vitrina).length !== 0  &&
        //     !(dmpCreatedAt >= start &&  dmpCreatedAt <= now)
    }
}

module.exports = DmpProf;